export const SEEDANCE_2_0_MODEL_KEY = 'SEEDANCE_2_0'

export const shouldPreferSeedance1080p = (
    modelKey: string | undefined,
    resolutions: Array<string> | null | undefined
) => {
    const list = Array.isArray(resolutions) ? resolutions : []
    return (
        modelKey === SEEDANCE_2_0_MODEL_KEY &&
        list.includes('1080p')
    )
}

export const pickPreferredVideoResolution = (
    resolutions: Array<string> | null | undefined,
    modelKey?: string
) => {
    const list = Array.isArray(resolutions) ? resolutions : []
    if (!list.length) return ''
    if (shouldPreferSeedance1080p(modelKey, list)) {
        return '1080p'
    }
    return list[0] || ''
}
